import { Network } from "@/network";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Log } from "@/util";

class AppropriationModel {
    private static sInstance: AppropriationModel;

    public static get instance(): AppropriationModel {
        if (!AppropriationModel.sInstance) {
            AppropriationModel.sInstance = new AppropriationModel();
        }

        return AppropriationModel.sInstance;
    }

    private storeUserPermissionMap = TCBReceiptApi.Protobuf.StoreUserPermissionMap.create();
    private reconciliationList = TCBReceiptApi.Protobuf.ReconciliationList.create();
    // 明細
    private appropriationMap = TCBReceiptApi.Protobuf.AppropriationMap.create(); // 前三筆
    private appropriation = TCBReceiptApi.Protobuf.Appropriation.create(); // 單筆
    private appropriationTotal = TCBReceiptApi.Protobuf.AppropriationTotal.create(); // 總計
    // 撥款彙總
    private appropriationSummaryMap = TCBReceiptApi.Protobuf.AppropriationSummaryMap.create(); // 前三筆
    // private appropriationSummary = TCBReceiptApi.Protobuf.AppropriationSummary.create(); // 單筆
    private appropriationSummary = TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.create(); // 單筆
    private appropriationSummaryTotal = TCBReceiptApi.Protobuf.AppropriationSummaryTotal.create(); // 單筆
    // 卡別彙總
    private appropriationSummaryByCardTypeCollectionMap = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.create(); // 前三筆
    private appropriationSummaryByCardTypeCollection = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.create(); // 單筆


    // 搜尋 - 特店清單
    public async getStoreSearch(storeInsertQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/reimbursement/get_store_list_by_tid_number",
            "post",
            storeInsertQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.storeUserPermissionMap = TCBReceiptApi.Protobuf.StoreUserPermissionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 搜尋 - 列表 - 特約商店請款交易查詢
    public async getReimbursement(appropriationQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_store_list_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.reconciliationList = TCBReceiptApi.Protobuf.ReconciliationList.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 明細 - 展開前三筆資料之map
    public async getAppropriationMap(
        appropriationQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.appropriationMap = TCBReceiptApi.Protobuf.AppropriationMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 明細 - 取得展開資料 (單一筆)
    public async getAppropriation(appropriationQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_specific_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.appropriation = TCBReceiptApi.Protobuf.Appropriation.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 明細 - 統計
    public async getAppropriationTotal(
        appropriationQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_total_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                this.appropriationTotal = TCBReceiptApi.Protobuf.AppropriationTotal.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 撥款彙總 - 展開前三筆資料之map
    public async getAppropriationSummaryMap(appropriationQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_summary_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.appropriationSummaryMap = TCBReceiptApi.Protobuf.AppropriationSummaryMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 撥款彙總 - 取得展開資料 (單一筆)
    public async getAppropriationSummary(appropriationQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_specific_summary_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                // this.appropriationSummary = TCBReceiptApi.Protobuf.AppropriationSummary.decode(
                this.appropriationSummary = TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 撥款彙總 - 統計
    public async getAppropriationSummaryTotal(
        appropriationQuery: Uint8Array
    ): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_summary_total_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                this.appropriationSummaryTotal = TCBReceiptApi.Protobuf.AppropriationSummaryTotal.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 卡別彙總 - 展開前三筆資料之map
    public async getAppropriationSummaryByCardTypeCollectionMap(appropriationQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_summary_by_card_type",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.appropriationSummaryByCardTypeCollectionMap = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 卡別彙總 - 取得展開資料 (單一筆)
    public async getAppropriationSummaryByCardTypeCollection(appropriationQuery: Uint8Array): Promise<void> {
        await Network.sendAPI(
            "/api/front/appropriation/get_specific_summary_by_card_type",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                this.appropriationSummaryByCardTypeCollection = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });
    }

    // 卡別彙總 - 統計
    public async getAppropriationSummaryByCardTypeCollectionTotal(
        appropriationQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal> {
        let total = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal.create();

        await Network.sendAPI(
            "/api/front/appropriation/get_summary_total_by_card_type",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );
                
                total = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeTotal.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return total;
    }

    /* ----列印頁面---- */
    public async getPrintAppropriationCollectionMap(
        appropriationQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.AppropriationMap> {
        let map = TCBReceiptApi.Protobuf.AppropriationMap.create();

        await Network.sendAPI(
            "/api/front/appropriation/get_print_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                map = TCBReceiptApi.Protobuf.AppropriationMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return map;
    }

    public async getPrintAppropriationSummaryMap(
        appropriationQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.AppropriationSummaryMap> {
        let map = TCBReceiptApi.Protobuf.AppropriationSummaryMap.create();

        await Network.sendAPI(
            "/api/front/appropriation/get_summary_print_by_condition",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                map = TCBReceiptApi.Protobuf.AppropriationSummaryMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return map;
    }

    public async getPrintAppropriationSummaryByCardTypeCollectionMap(
        appropriationQuery: Uint8Array
    ): Promise<TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap> {
        let map = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.create();

        await Network.sendAPI(
            "/api/front/appropriation/get_summary_print_by_card_type",
            "post",
            appropriationQuery
        )
            .then((rawResponse) => {
                const response = TCBReceiptApi.Protobuf.Response.decode(
                    new Uint8Array(rawResponse.data as ArrayBufferLike)
                );

                map = TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap.decode(
                    new Uint8Array(response.item)
                );
            })
            .catch((error) => {
                Log.error(error);
            });

        return map;
    }    
    /* ----列印頁面---- */

    // 取得特店清單列表
    public getStoreList(): TCBReceiptApi.Protobuf.StoreUserPermissionMap {
        return this.storeUserPermissionMap;
    }

    // 取得搜尋結果 - 列表
    public getReimbursementList(): TCBReceiptApi.Protobuf.ReconciliationList {
        return this.reconciliationList;
    }

    // 取得 明細 - 展開資料map (前三筆)
    public getAppropriationMapData(): TCBReceiptApi.Protobuf.AppropriationMap {
        return this.appropriationMap;
    }

    // 取得 明細 - 取得展開資料 (單一筆)
    public getAppropriationData(): TCBReceiptApi.Protobuf.Appropriation {
        return this.appropriation;
    }

    // 取得 明細 - 統計
    public getAppropriationTotalData(): TCBReceiptApi.Protobuf.AppropriationTotal {
        return this.appropriationTotal;
    }

    // 取得 撥款彙總 - 展開資料map (前三筆)
    public getAppropriationSummaryMapData(): TCBReceiptApi.Protobuf.AppropriationSummaryMap {
        return this.appropriationSummaryMap;
    }

    // 取得 撥款彙總 - 取得展開資料 (單一筆)
    // public getAppropriationSummaryData(): TCBReceiptApi.Protobuf.AppropriationSummary {
    public getAppropriationSummaryData(): TCBReceiptApi.Protobuf.AppropriationSummaryTerminalNoMap {
        return this.appropriationSummary;
    }

    // 取得 撥款彙總 - 統計
    public getAppropriationSummaryTotalData(): TCBReceiptApi.Protobuf.AppropriationSummaryTotal {
        return this.appropriationSummaryTotal;
    }

    // 取得 卡別彙總 - 展開資料map (前三筆)
    public getAppropriationSummaryByCardTypeCollectionMapData(): TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollectionMap {
        return this.appropriationSummaryByCardTypeCollectionMap;
    }

    // 取得 卡別彙總 - 取得展開資料 (單一筆)
    public getAppropriationSummaryByCardTypeCollectionData(): TCBReceiptApi.Protobuf.AppropriationSummaryByCardTypeCollection {
        return this.appropriationSummaryByCardTypeCollection;
    }

    // 取得撥款匯出
    public async exportAppropriation(queryString: string): Promise<void> {
        const uri = "/api/front/appropriation/get_export_by_condition?" + queryString;
        await Network.downloadFile(uri);
    }
}

const appropriationModel = AppropriationModel.instance;

export { appropriationModel as AppropriationModel };
